import { render, staticRenderFns } from "./HappinessPage.vue?vue&type=template&id=6f3db12b&scoped=true&"
import script from "./HappinessPage.vue?vue&type=script&lang=js&"
export * from "./HappinessPage.vue?vue&type=script&lang=js&"
import style0 from "./HappinessPage.vue?vue&type=style&index=0&id=6f3db12b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3db12b",
  null
  
)

export default component.exports